import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

// Promoted from sub-bucket 9's inlined dashboard-page version once a second
// admin surface needed the same dashed-border empty block. Used across
// admin partner list/detail empty states.
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center rounded-lg border border-dashed border-border/70 bg-muted/20 px-6 py-10 text-center",
        className,
      )}
    >
      {Icon && <Icon className="mb-3 h-5 w-5 text-muted-foreground/70" />}
      <p className="text-sm font-medium">{title}</p>
      {description && (
        <p className="mt-1 max-w-xs text-xs text-muted-foreground">
          {description}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
